import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import { FormCaregiverInfo, FormInsurerInfo, FormPatientInfo, FormReferralInfo } from 'components/simContactForms';

const SimPopupBoxForm = ({ onClose, open, Caregiver, Insurer, Patient, Referral }) => {
	const theme = useTheme();

	return (
		<Dialog
			onClose={onClose}
			open={open}
			maxWidth={'lg'}
			sx={{
				'& .MuiPaper-root': {
					borderRadius: '2vw',
					bgcolor: theme.palette.background.default,
					paddingY: '2vw'
				},
				top: '0vh',
				height: '100vh',
				overflowY: 'scroll',

				'&::-webkit-scrollbar': {
					display: 'none',
					width: '0px'
				},
				'&::-webkit-scrollbar-track': {
					backgroundColor: '#A0A0A0'
				},
				'&::-webkit-scrollbar-thumb': {
					backgroundColor: '#7D7C7C',
					borderRadius: '5px',
					marginX: '1px'
				}
			}}>
			{Caregiver && <FormCaregiverInfo onClose={onClose} />}
			{Insurer && <FormInsurerInfo onClose={onClose} />}
			{Patient && <FormPatientInfo onClose={onClose} />}
			{Referral && <FormReferralInfo onClose={onClose} />}
		</Dialog>
	);
};

SimPopupBoxForm.propTypes = {
	onClose: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired
};

export default SimPopupBoxForm;
